import React, { useEffect, useRef } from "react";
import "../styles/AboutUs.css";
import OGduo from "../../../assets/Images/OG duo.jpg";
import Yogesh1 from "../../../assets/Images/yogesh1.png";
import Rashi from "../../../assets/Images/Rashi.png"
import Bhavesh1 from "../../../assets/Images/Bhavesh1.png"
import Rashmi1 from "../../../assets/Images/Rashmi1.jpg"

function AboutUs() {
  const timelineRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".fade-in");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-container">
      {/* Hero Section */}

      {/* Enhanced Project Overview */}
      <section className="overview-section fade-in">
        <div className="aboutcontainer">
          <h2 className="section-title">About Our Project</h2>

          {/* Mission Statement */}
          <div className="mission-statement">
            <h3>Our Mission</h3>
            <p>
              To revolutionize computer science education by making complex data
              structures and algorithms accessible through interactive, visual
              learning experiences that bridge the gap between theory and
              understanding.
            </p>
          </div>

          {/* Key Features */}
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h4>Interactive Learning</h4>
              <p>
                Step-by-step visualization of algorithm execution with
                user-controlled pace and detailed explanations.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h4>Multiple Data Structures</h4>
              <p>
                Comprehensive coverage of arrays, trees, graphs, linked lists,
                stacks, queues, and hash tables.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h4>Algorithm Comparison</h4>
              <p>
                Side-by-side comparison of different algorithms with time and
                space complexity analysis.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎨</div>
              <h4>Intuitive Interface</h4>
              <p>
                Clean, modern design with responsive layout that works
                seamlessly across all devices.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📚</div>
              <h4>Educational Focus</h4>
              <p>
                Designed specifically for engineering students with
                curriculum-aligned content and examples.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🚀</div>
              <h4>Performance Optimized</h4>
              <p>
                Fast, efficient visualizations that handle large datasets
                without compromising user experience.
              </p>
            </div>
          </div>

          {/* Project Goals */}
          <div className="goals-section">
            <h3>Project Goals</h3>
            <div className="goals-list">
              <div className="goal-item">
                <span className="goal-number">01</span>
                <div className="goal-content">
                  <h5>Enhance Learning Experience</h5>
                  <p>
                    Make abstract concepts tangible through visual
                    representation
                  </p>
                </div>
              </div>
              <div className="goal-item">
                <span className="goal-number">02</span>
                <div className="goal-content">
                  <h5>Improve Academic Performance</h5>
                  <p>
                    Help students achieve better understanding and grades in DSA
                    courses
                  </p>
                </div>
              </div>
              <div className="goal-item">
                <span className="goal-number">03</span>
                <div className="goal-content">
                  <h5>Bridge Theory-Practice Gap</h5>
                  <p>
                    Connect theoretical knowledge with practical implementation
                  </p>
                </div>
              </div>
              <div className="goal-item">
                <span className="goal-number">04</span>
                <div className="goal-content">
                  <h5>Foster Innovation</h5>
                  <p>
                    Inspire students to think creatively about problem-solving
                    approaches
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="Atimeline-section fade-in">
        <div className="container">
          <h2 className="section-title">Project Timeline</h2>
          <div className="Atimeline" ref={timelineRef}>
            <div className="Atimeline-item">
              <div className="Atimeline-marker"></div>
              <div className="Atimeline-content">
                <h3>Semester V - Concept Birth</h3>
                <p className="Atimeline-date">Initial Development Phase</p>
                <p>
                  Started with sorting algorithm visualization using HTML, CSS,
                  and JavaScript.
                </p>
                <div className="tech-stack">
                  <span className="tech-tag">HTML</span>
                  <span className="tech-tag">CSS</span>
                  <span className="tech-tag">JavaScript</span>
                </div>
              </div>
            </div>

            <div className="Atimeline-item">
              <div className="Atimeline-marker"></div>
              <div className="Atimeline-content">
                <h3>Semester VI - Feature Expansion</h3>
                <p className="Atimeline-date">Enhanced Functionality</p>
                <p>
                  Added more sorting algorithms and improved user interface
                  design.
                </p>
                <div className="tech-stack">
                  <span className="tech-tag">Advanced JS</span>
                  <span className="tech-tag">Responsive Design</span>
                </div>
              </div>
            </div>

            <div className="Atimeline-item">
              <div className="Atimeline-marker"></div>
              <div className="Atimeline-content">
                <h3>Semester VII - Technology Upgrade</h3>
                <p className="Atimeline-date">Framework Migration</p>
                <p>
                  Migrated to React.js for better component management and
                  scalability.
                </p>
                <div className="tech-stack">
                  <span className="tech-tag">React.js</span>
                  <span className="tech-tag">Component Architecture</span>
                </div>
              </div>
            </div>

            <div className="Atimeline-item">
              <div className="Atimeline-marker"></div>
              <div className="Atimeline-content">
                <h3>Final Year - Major Project</h3>
                <p className="Atimeline-date">Comprehensive Development</p>
                <p>
                  Expanded to include trees, graphs, linked lists, and advanced
                  algorithms.
                </p>
                <div className="tech-stack">
                  <span className="tech-tag">Data Structures</span>
                  <span className="tech-tag">Advanced Algorithms</span>
                  <span className="tech-tag">External CSS</span>
                </div>
              </div>
            </div>

            <div className="Atimeline-item">
              <div className="Atimeline-marker achievement"></div>
              <div className="Atimeline-content">
                <h3>Top 5 Recognition</h3>
                <p className="Atimeline-date">Department Achievement</p>
                <p>
                  Ranked among Top 5 projects in the IT Department for
                  innovation and impact.
                </p>
                <div className="achievement-badge">
                  <span className="achievement-icon">🥇</span>
                  Top 5 IT Department Project
                </div>
              </div>
            </div>

            <div className="Atimeline-item">
              <div className="Atimeline-marker patent"></div>
              <div className="Atimeline-content">
                <h3>Patent Granted</h3>
                <p className="Atimeline-date">Official Recognition</p>
                <p>
                  Unique visualization approach officially granted a patent for
                  educational innovation in algorithm learning.
                </p>
                <div className="achievement-badge">
                  <span className="patent-icon">📜</span>
                  Patent Granted
                </div>
                <div className="granted-status">✓ &nbsp;GRANTED</div>
              </div>
            </div>

            <div className="Atimeline-item">
              <div className="Atimeline-marker"></div>
              <div className="Atimeline-content">
                <h3>Current - Continuous Enhancement</h3>
                <p className="Atimeline-date">Ongoing Development</p>
                <p>
                  Regular updates with new algorithms and improved user
                  experience.
                </p>
                <div className="tech-stack">
                  <span className="tech-tag">Performance Optimization</span>
                  <span className="tech-tag">User Feedback Integration</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Developers Section */}
       <section className="developers-section fade-in">
        <div className="container">
          <h2 className="section-title">The Innovation Team</h2>
          <div className="team-showcase">
            <div className="team-image">
              <img src={OGduo} alt="Development Team" />
            </div>
            <div className="team-content">
              <h3>From Idea to Innovation</h3>
              <p className="team-intro">
                <strong>Abhishek Joshi & Harsh Patel</strong>
              </p>
              <p className="team-description">
                Two passionate IT students who transformed a simple concept into a groundbreaking
                educational tool. Starting with a basic idea to visualize sorting algorithms, they
                embarked on a journey
                that would revolutionize how students learn data structures and algorithms.
              </p>
              <p className="team-description">
                Through countless hours of research, development, and testing, they created an innovative platform that
                bridges the gap between theoretical knowledge and practical understanding. Their dedication to making
                complex concepts accessible led to breakthrough visualization techniques that earned recognition from
                both academic peers and industry professionals.
              </p>
              <p className="team-description">
                What started as a semester project evolved into a comprehensive educational tool that may impact
                thousands of students. Their collaborative approach, combining technical expertise with educational
                insight, resulted in a patent-worthy innovation that stands among the top projects in their department.
              </p>
              <div className="team-achievements">
                <div className="achievement-item">
                  <span className="achievement-icon">🏆</span>
                  <span>Top 5 IT Department Project</span>
                </div>
                <div className="achievement-item">
                  <span className="achievement-icon">📜</span>
                  <span>Patent Granted</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Other Contributors Section */}
      <section className="contributors-section fade-in">
        <div className="container">
          <h2 className="section-title">Other Contributors</h2>
          <div className="contributors-grid">
            <div className="contributor-card">
              <div className="contributor-avatar">
                <img
                  src={Yogesh1}
                  alt="Contributor 1"
                />
              </div>
              <h3>Yogesh Tiwari</h3>
              <p className="contributor-role">Developer</p>
            </div>

            <div className="contributor-card">
              <div className="contributor-avatar">
                <img
                  src={Rashi}
                  alt="Contributor 2"
                />
              </div>
              <h3>Rashi Bhanushali</h3>
              <p className="contributor-role">Developer</p>
            </div>
          </div>
        </div>
      </section>

      {/* Professors Section */}
      <section className="professors-section fade-in">
        <div className="container">
          <h2 className="section-title">Under the Guidance of</h2>
          <div className="professors-grid">
            <div className="professor-card">
              <div className="professor-avatar">
                <img
                  src={Bhavesh1}
                  alt="Professor 1"
                />
              </div>
              <h3 className="professor-name1">Dr. Bhavesh Patel</h3>
              <p className="professor-title1">
                Principal of Shah and Anchor Kutchhi Engineering College
              </p>
            </div>

            <div className="professor-card">
              <div className="professor-avatar">
                <img
                  src={Rashmi1}
                  alt="Professor 2"
                />
              </div>
              <h3  className="professor-name2">Dr. Rashmi Malvankar</h3>
              <p className="professor-title2">Assistant Professor</p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="impact-section fade-in">
        <div className="container">
          <h2 className="section-title">Our Impact</h2>
          <div className="impact-stats">
            <div className="stat-card">
              <div className="stat-number">10+</div>
              <div className="aboutstat-label">Data Structures</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">25+</div>
              <div className="aboutstat-label">Algorithms</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">1</div>
              <div className="aboutstat-label">Patent Granted</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default AboutUs;
